import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-24 bg-gray-50 gap-4"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin h-8 w-8 text-blue-500",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1)
const _hoisted_3 = { class: "w-56" }
const _hoisted_4 = { class: "w-full bg-gray-200 rounded-full h-1.5 overflow-hidden" }
const _hoisted_5 = { class: "text-xs text-gray-400 text-center mt-1" }
const _hoisted_6 = { class: "flex items-center bg-gray-800 text-white px-3 py-2 gap-3 min-h-11" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_8 = { class: "flex items-center gap-0.5 shrink-0" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"20px","line-height":"1"}
}, " zoom_out ", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "text-xs w-11 text-center opacity-60 select-none tabular-nums" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"20px","line-height":"1"}
}, " zoom_in ", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  class: "material-icons-outlined",
  style: {"font-size":"20px","line-height":"1"}
}
const _hoisted_18 = ["title"]
const _hoisted_19 = {
  class: "material-icons-outlined",
  style: {"font-size":"20px","line-height":"1"}
}
const _hoisted_20 = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center bg-gray-200/80 z-10"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin h-6 w-6 text-blue-500",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 0,
  class: "flex items-center justify-between bg-gray-800 text-white px-3 py-2"
}
const _hoisted_24 = ["disabled"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"18px","line-height":"1"}
}, " chevron_left ", -1)
const _hoisted_26 = { class: "flex items-center gap-2 text-sm" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "opacity-60" }, "Page", -1)
const _hoisted_28 = ["max"]
const _hoisted_29 = { class: "opacity-60" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"18px","line-height":"1"}
}, " chevron_right ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_pdf_embed = _resolveComponent("vue-pdf-embed")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "rootEl",
    class: _normalizeClass(["w-full rounded-xl overflow-hidden border border-gray-200 shadow-sm bg-white", { 'h-screen flex flex-col rounded-none': _ctx.isFullscreen }])
  }, [
    (_ctx.downloading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "bg-blue-500 h-1.5 rounded-full transition-all duration-200",
                style: _normalizeStyle({ width: `${_ctx.downloadProgress}%` })
              }, null, 4)
            ]),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.downloadProgress > 0 ? `${_ctx.downloadProgress}%` : "Loading…"), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.zoomOut && _ctx.zoomOut(...args))),
                disabled: _ctx.atMinZoom,
                title: "Zoom out",
                class: "p-1.5 rounded hover:bg-white/10 disabled:opacity-30 transition-colors"
              }, _hoisted_11, 8, _hoisted_9),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.zoomLabel), 1),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.zoomIn && _ctx.zoomIn(...args))),
                disabled: _ctx.atMaxZoom,
                title: "Zoom in",
                class: "p-1.5 rounded hover:bg-white/10 disabled:opacity-30 transition-colors"
              }, _hoisted_15, 8, _hoisted_13),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('download'))),
                disabled: _ctx.downloadingFile,
                title: "Download",
                class: "p-1.5 rounded hover:bg-white/10 disabled:opacity-30 transition-colors ml-1"
              }, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.downloadingFile ? "hourglass_top" : "file_download"), 1)
              ], 8, _hoisted_16),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleFullscreen && _ctx.toggleFullscreen(...args))),
                title: _ctx.isFullscreen ? 'Exit fullscreen' : 'Fullscreen',
                class: "p-1.5 rounded hover:bg-white/10 transition-colors"
              }, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.isFullscreen ? "fullscreen_exit" : "fullscreen"), 1)
              ], 8, _hoisted_18)
            ])
          ]),
          _createElementVNode("div", {
            ref: "renderArea",
            class: _normalizeClass(["bg-gray-200 flex justify-center py-6 relative", _ctx.isFullscreen ? 'flex-1 overflow-auto items-center' : 'overflow-x-auto']),
            style: {"min-height":"520px"}
          }, [
            (_ctx.isRendering)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
              : _createCommentVNode("", true),
            _createVNode(_component_vue_pdf_embed, {
              ref: "pdfRef",
              source: _ctx.base64Source,
              page: _ctx.currentPage,
              width: _ctx.width,
              onRendered: _ctx.handleRender
            }, null, 8, ["source", "page", "width", "onRendered"])
          ], 2),
          (_ctx.pageCount > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
                  disabled: _ctx.currentPage <= 1,
                  class: "flex items-center gap-0.5 px-2 py-1 rounded hover:bg-white/10 disabled:opacity-30 transition-colors text-sm"
                }, [
                  _hoisted_25,
                  _createTextVNode(" Previous ")
                ], 8, _hoisted_24),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pageInput) = $event)),
                    onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.jumpToPage && _ctx.jumpToPage(...args))),
                    onKeyup: _cache[7] || (_cache[7] = _withKeys(
//@ts-ignore
(...args) => (_ctx.jumpToPage && _ctx.jumpToPage(...args)), ["enter"])),
                    min: "1",
                    max: _ctx.pageCount,
                    class: "w-12 text-center text-gray-900 bg-white rounded px-1 py-0.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                  }, null, 40, _hoisted_28), [
                    [
                      _vModelText,
                      _ctx.pageInput,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_29, "of " + _toDisplayString(_ctx.pageCount), 1)
                ]),
                _createElementVNode("button", {
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                  disabled: _ctx.currentPage >= _ctx.pageCount,
                  class: "flex items-center gap-0.5 px-2 py-1 rounded hover:bg-white/10 disabled:opacity-30 transition-colors text-sm"
                }, [
                  _createTextVNode(" Next "),
                  _hoisted_31
                ], 8, _hoisted_30)
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ], 2))
}